// Option sets for the rich-text bubble toolbar.
//
// NOTE ON COLORS: these are *content* colors a provider applies to their own
// note text (author intent baked into the saved HTML), not UI chrome — so they
// are concrete values, not theme tokens. Inline `style="color: rgb(var(--x))"`
// does not survive the editor's HTML round-trip (the browser can't resolve the
// custom property when the mark is re-parsed), and a saved clinical note must
// render/print the same color everywhere, including outside the app's theme.

export interface FontSizeOption {
  label: string;
  // undefined => clear the size back to the block default (Normal)
  value?: string;
}

export const FONT_SIZE_OPTIONS: FontSizeOption[] = [
  { label: "Default", value: undefined },
  { label: "12", value: "12px" },
  { label: "14", value: "14px" },
  { label: "16", value: "16px" },
  { label: "18", value: "18px" },
  { label: "20", value: "20px" },
  { label: "24", value: "24px" },
  { label: "30", value: "30px" },
  { label: "36", value: "36px" },
];

export interface ColorOption {
  label: string;
  // The swatch/applied CSS color. undefined => clear the color.
  value?: string;
}

// Foreground text colors.
export const TEXT_COLOR_OPTIONS: ColorOption[] = [
  { label: "Default", value: undefined },
  { label: "Gray", value: "#6b7280" },
  { label: "Red", value: "#dc2626" },
  { label: "Orange", value: "#ea580c" },
  { label: "Amber", value: "#b45309" },
  { label: "Green", value: "#16a34a" },
  { label: "Teal", value: "#0d9488" },
  { label: "Blue", value: "#2563eb" },
  { label: "Indigo", value: "#4f46e5" },
  { label: "Purple", value: "#9333ea" },
  { label: "Pink", value: "#db2777" },
];

// Highlight (background) colors — soft tints that keep dark text readable.
export const HIGHLIGHT_COLOR_OPTIONS: ColorOption[] = [
  { label: "None", value: undefined },
  { label: "Yellow", value: "#fef9c3" },
  { label: "Orange", value: "#ffedd5" },
  { label: "Red", value: "#fee2e2" },
  { label: "Green", value: "#dcfce7" },
  { label: "Teal", value: "#ccfbf1" },
  { label: "Blue", value: "#dbeafe" },
  { label: "Purple", value: "#f3e8ff" },
  { label: "Pink", value: "#fce7f3" },
  { label: "Gray", value: "#e5e7eb" },
];
